import { render, staticRenderFns } from "./PeriodItem.vue?vue&type=template&id=1ba7c81c&scoped=true"
import script from "./PeriodItem.vue?vue&type=script&lang=js"
export * from "./PeriodItem.vue?vue&type=script&lang=js"
import style0 from "./PeriodItem.vue?vue&type=style&index=0&id=1ba7c81c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba7c81c",
  null
  
)

export default component.exports